/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReportWhsEomEditor extends Serenity.Extensions.GridEditorBase<IcReportWhsEomRow> {
        protected getColumnsKey() { return "InventoryReport.IcReportWhsEom"; }
        protected getDialogType() { return IcReportWhsEomDialog; }
        protected getLocalTextPrefix() { return IcReportWhsEomRow.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReportWhsEomService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

